<template>
	<div>
		<a-modal id='quanxian1' width='40rem' v-model="visible" on-ok="handleOk1"
			v-dragModal :dialog-style="{ top:'30vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;">
					新建用户
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 38rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 1.5rem;position: relative;left: -.5rem;">
					<a-form-model ref='form' :model="form" labelAlign='left' layout='vertical' :rules='rules'
						hideRequiredMark>
						<a-row>
							<a-col :span='1'></a-col>
							<a-col :span='11'>
								<a-form-model-item prop='name' label='員工姓名'>
									<a-input v-model="form.name" :maxLength='20' />
								</a-form-model-item>
							</a-col>
							<a-col :span='1'></a-col>
							<a-col :span='11'>
								<a-form-model-item prop='email' label='電郵地址'>
									<a-input v-model="form.email" @blur='emailfn'/>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span='1'></a-col>
							<a-col :span='11'>
								<a-form-model-item label='使用者類型' prop='position'>
									<Situationall v-model="form.position" :url='$api.getParamList'
										:params='{"type":"position"}' :style='"width:100%"' :placeholder="'請選擇'">
									</Situationall>
								</a-form-model-item>
							</a-col>
							<a-col :span='1'></a-col>
							<a-col :span='11'>
								<a-form-model-item prop='status' label='狀態'>
									<div style='width:80%'> 
											<a-radio-group v-model="form.status">
												<a-radio :value="1">使用中</a-radio>
												<a-radio :value="2">已暫停</a-radio>
											</a-radio-group>
									</div>
								</a-form-model-item>
							</a-col>
						</a-row>
					</a-form-model>
					<div style="text-align: center;">
						<button class='btn1 btnx' @click='handbect("form")'  v-html='"保&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;存"'>保存</button>
						<!-- <button class='btn1 btn2' @click='resetForm("form")'>清除</button> -->
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['items'],
		data() {
			return {
				domainlist:[],
				visible: true,
				rules: {
					email:[{required:true,message:' ',trigger:'blur'}],
					position:[{required:true,message:' ',trigger:'change'}],
					system_type:[{required:true,message:' ',trigger:'change'}],
					name:[{required:true,message:' ',trigger:'blur'}],
				},
				form: {
					"email":"",
					 "position":"",
					 "status":1,
					 name:'',
				},
			}
		},

		mounted() {
			console.log(this.items)
			// if(this.items){
			// 	this.handz()
			// }
			this.getdata()
		},
		methods: {
			emailfn() {
				if (this.form.email) {
					var t = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
					if (!(t.test(this.form.email))) {
						this.form.email = ''
						this.$message.warning('請輸入正確的電郵地址')
					}
				}
			},
			getdata() {
				this.$ajax({
				method: 'post',
					url: this.$api.getParamList,
					data: {
						 "type":"position"
					}
				}).then(res => {
					if (res.data) {
						this.domainlist = res.data.result
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}})
			},
			handz(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.newAdminUser,
					data:this.form
				}).then(res => {
					if (res.data) {
						this.form = res.data
						// App.oTool.successT();
						console.log(this.form)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				// this.handz()
			},
			//下单
			handbect(ruleForm) {
				 this.$refs[ruleForm].validate(valid => {
				        if (valid) {
							this.form.token = this.$store.state.token;
							this.$ajax({
								method: 'post',
								url: this.$api.newAdminUser,
								data: this.form
							}).then(res => {
								if (res.data.qmiscode === 1000) {
									App.oTool.successT();
									this.$emit('child', 1)
								} else {
									App.oTool.warningT(res.data.qmismsg);
								}
							})
				        } else {
				          console.log('error submit!!');
				          return false;
				        }
				      });
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#quanxian1 {
		.ant-form-explain{
			display: none;
		}

		.ant-form-item, .ant-form-item-control{
			width: 100%;
		}
		
		.ant-form-item-control-wrapper{
			width: 90% !important;
			.ant-form-item-control{
				width: 100%;
			}
		}

		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}


		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.ant-modal-body {
			background-color: #e5e5e5 !important;
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
</style>
